import React from 'react';
import { bool, func, number, string } from 'prop-types';
import { OpenedEyeIcon } from '@snapask/common-components';

import useStyles from 'hooks/useStyles';
import useGetFreeTrialInfo from 'hooks/useGetFreeTrialInfo';

import styles from './WatchForFreeLink.scss';

export default function WatchForFreeLink({ isShow, onClick, id, name }) {
  useStyles(styles);

  const {
    buttonText,
    isAllowFreeTrialRegion,
    handleTriggerFreeTrialLink,
  } = useGetFreeTrialInfo({
    id,
    name,
    section: 'topic_upcoming_episode',
    type: 'regular_class',
  });

  const handleClick = event => {
    handleTriggerFreeTrialLink();
    onClick(event);
  };

  if (!isAllowFreeTrialRegion || !isShow) return null;
  return (
    <div className={styles.root} onClick={handleClick}>
      <div>{buttonText}</div>
      <OpenedEyeIcon className={styles.icon} />
    </div>
  );
}

WatchForFreeLink.propTypes = {
  isShow: bool,
  onClick: func,
  id: number,
  name: string,
};

WatchForFreeLink.defaultProps = {
  isShow: true,
  onClick: () => {},
  id: null,
  name: '',
};
